export const stats = [
  { value: '10', label: 'GOTOWYCH MODUŁÓW' },
  { value: '500+', label: 'STRON MATERIAŁÓW' },
  { value: '100%', label: 'ZGODNE Z PODSTAWĄ' },
  { value: '100%', label: 'DO DRUKU I ONLINE' },
]

export const miniStats = [
  { value: '500+', label: 'stron materiałów' },
  { value: '4 → Matura', label: 'pełny zakres klas' },
  { value: '100%', label: 'gotowe do druku' },
]

export const beforeItems = [
  'Godziny szukania inspiracji w internecie po pracy',
  'Ciągłe wątpliwości, czy temat jest zgodny z podstawą',
  'Drukarka i ksero w pośpiechu dziesięć minut przed lekcją',
  'Powtarzalne, te same techniki w każdej klasie',
  'Poczucie, że nigdy nie jesteś w pełni przygotowana',
]

export const afterItems = [
  'Gotowy plan lekcji na cały rok szkolny',
  'Zgodność z podstawą programową w każdym module',
  'Karty pracy, instrukcje i kryteria oceny w jednym pliku',
  'Aktywności różnicowane dla każdego poziomu klasy',
  'Spokój i pewność, że każda lekcja jest zaplanowana',
]

export const recognizeItems = [
  'Tydzień przed lekcją nadal szukasz pomysłu na zajęcia.',
  'Karty pracy tworzysz sama, nocami, po całym dniu pracy.',
  'Nie masz pewności, czy temat wpisuje się w podstawę.',
  'Prace uczniów wychodzą podobne, bo brakuje nowych technik.',
  'Zastępstwo z plastyki to dla Ciebie stres i improwizacja.',
]

export type IncludedItem = {
  icon: 'layers' | 'clipboard' | 'printer' | 'award' | 'monitor' | 'image'
  title: string
  description: string
}

export const includedItems: IncludedItem[] = [
  {
    icon: 'layers',
    title: '10 Kompletnych Modułów',
    description: 'Każdy moduł to gotowy cykl lekcji z celami, przebiegiem i podsumowaniem.',
  },
  {
    icon: 'clipboard',
    title: 'Scenariusze Lekcji',
    description: 'Minuta po minucie: wprowadzenie, ćwiczenie, prezentacja prac i ocena.',
  },
  {
    icon: 'printer',
    title: 'Karty Pracy i Szablony',
    description: 'Gotowe do druku arkusze, kontury i szablony dla każdego poziomu klasy.',
  },
  {
    icon: 'award',
    title: 'Kryteria Oceniania',
    description: 'Jasne rubryki i kryteria, które oszczędzają czas przy sprawdzaniu prac.',
  },
  {
    icon: 'monitor',
    title: 'Prezentacje',
    description: 'Slajdy z przykładami dzieł i technik, gotowe do wyświetlenia w klasie.',
  },
  {
    icon: 'image',
    title: 'Pomoce Wizualne',
    description: 'Plansze, karty inspiracji i przykłady prac uczniów do powieszenia w sali.',
  },
]

export const bonuses = [
  {
    number: 1,
    title: 'PLAKATY GOTOWE',
    description: '12 plakatów A3 do Twojej sali',
    value: 'Wartość 79 zł',
    image:
      'https://cdn.magicpatterns.com/uploads/9gqaUtN6pTCoT8JaRxAuj3/Captura_de_pantalla_2026-09-11_a_la(s)_12.11.52_p._m..png',
  },
  {
    number: 2,
    title: 'MAPA POSTĘPÓW',
    description: 'cały rok plastyki na jednej kartce',
    value: 'Wartość 69 zł',
    image:
      'https://cdn.magicpatterns.com/uploads/5qSwoo91FLyyEXTGQshLQ4/Captura_de_pantalla_2026-09-11_a_la(s)_12.12.05_p._m..png',
  },
  {
    number: 3,
    title: 'KARTY GOTOWE',
    description: '120 kart do wycięcia',
    value: 'Wartość 59 zł',
    image:
      'https://cdn.magicpatterns.com/uploads/2hEQhjTTCaZn7gBryEaCg4/Captura_de_pantalla_2026-09-11_a_la(s)_12.12.14_p._m..png',
  },
  {
    number: 4,
    title: '30 PYTAŃ DO KAŻDEGO DZIEŁA',
    description: 'uniwersalny zestaw nauczyciela',
    value: 'Wartość 49 zł',
    image:
      'https://cdn.magicpatterns.com/uploads/2gEGFs1p7Ezxmju9aNAg6g/Captura_de_pantalla_2026-09-11_a_la(s)_12.12.23_p._m..png',
  },
  {
    number: 5,
    title: 'GAZETKI GOTOWE',
    description: 'kalendarz dekoracji na cały rok szkolny',
    value: 'Wartość 59 zł',
    image:
      'https://cdn.magicpatterns.com/uploads/xeDkFLdWZtj8JqowaabsGW/Captura_de_pantalla_2026-09-11_a_la(s)_12.12.31_p._m..png',
  },
]

export const priceRows = [
  { label: 'Pakiet PLASTYKA GOTOWA™', value: '349 zł' },
  { label: '5 ekskluzywnych dodatków', value: '315 zł' },
]

export const testimonials = [
  {
    quote:
      'Pierwszy raz od lat weszłam do klasy bez stresu. Plan lekcji, karty pracy i kryteria oceny miałam w jednym pliku — wystarczyło wydrukować.',
    name: 'Monika K.',
    role: 'nauczycielka plastyki, klasy 4–8',
  },
  {
    quote:
      'Zamawiałam z ciekawości, została mi cała jesień przygotowana. Uczniowie w końcu robią różne rzeczy, a nie po raz setny ten sam plakat.',
    name: 'Agnieszka W.',
    role: 'nauczycielka plastyki i techniki',
  },
]

export const faqs = [
  {
    question: 'Jak otrzymam materiały?',
    answer:
      'Bezpośrednio po płatności dostaniesz e-mail z linkiem do pobrania wszystkich plików PDF. Dostęp masz od razu i na zawsze — bez logowania i bez subskrypcji.',
  },
  {
    question: 'Czy materiały są zgodne z podstawą programową?',
    answer:
      'Tak. Każdy moduł zawiera odniesienie do konkretnych wymagań podstawy programowej dla szkoły podstawowej, więc możesz spokojnie wpisać go do rozkładu materiału.',
  },
  {
    question: 'Dla jakich klas są materiały?',
    answer:
      'Pakiet obejmuje klasy 4–8 szkoły podstawowej. Każda aktywność ma wariant łatwiejszy i trudniejszy, dzięki czemu wykorzystasz ją na różnych poziomach.',
  },
]
